import React, { useEffect } from "react";
import { useEsfContext } from "../_EsfWalkThrough/EsfContext";import { useTranslation } from "react-i18next";
import { colors, fonts, frames, glyphs } from "../../../Styles";
import { useStationStatusById } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/StationStatusSlice";
import { Station } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations";
import { WaitAnimation } from "../../BaseComponents";
import { useAppDispatch } from "../../../Store";
import { fetchStationStatusByStationIdsThunk } from "../../../Store/Thunks/stationStatusByIds";
import { getGateMotorConfig } from "../StationLayouts/esfStationCore";

interface ActiveStationsGateStateListProps {
  focus_view?: boolean;
}

export default function ActiveStationsGateStateList({ focus_view }: ActiveStationsGateStateListProps) {
  const { state: { selectedStations } } = useEsfContext();
    
    if (!selectedStations || selectedStations?.length === 0) return;
  
    return (
      selectedStations.map((station) => {
        return (
          <ActiveStationRow key={"station_" + station.station_id} station={station} focus_view={focus_view ?? false}/>
        )
      })
    )
  }
  
function ActiveStationRow({ station, focus_view }: { station: Station, focus_view: boolean }) {
    const { t } = useTranslation();
    const gateMotorConfig = getGateMotorConfig(t);
    const { isLoading, entity: stationStatus } = useStationStatusById(station.station_id);
  
    return (
      <div style={{display: "grid", gridTemplateColumns: "80px 1fr", gap: "10px"}}>
        <p style={{ height: "20px", color: colors.greyDarkPrimary, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), ...fonts.paragraph }}>
          {`${t("esfWalkThroughPages.esfWalkThrough.station", {
            defaultValue: "Station",
          })} ${station.name}`}
        </p>
        <div style={{ height: "20px", color: colors.greyDarkPrimary, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), ...fonts.paragraph }}>
          {isLoading ? <WaitAnimation/> : stationStatus && stationStatus.gateState !== undefined ? ( stationStatus.gateState === 0 ? <WaitAnimation/> :
            <p>{gateMotorConfig[Number(stationStatus?.gateState)]?.label}</p>
          ) : <p>{t("noData", { defaultValue: "no data" })}</p> }
          </div>
      </div>
    );
  }